module.exports = __webpack_public_path__ + "img/ep1-5.345dffa1.png";